module.exports = __webpack_public_path__ + "1e9ffa9d7118ce1b7faf834766852d8d.jpg";